<template>
  <div>
    <profile-sidebar />

    <div class="responsive-main">
      <expand-menu-icon></expand-menu-icon>
      <b-row class="main-page">
        <b-col>
          <div class="rounded bg-lightblack ml-1 mr-1 pl-3 pr-3 pb-3">
            <div class="text-center">
              <div class="cursor-pointer">
                <b-img
                  style="margin-top: -40px"
                  :src="
                    photoURL ||
                    'https://firebasestorage.googleapis.com/v0/b/anyverse-f5dd9.appspot.com/o/images%2Fprofile.svg?alt=media&token=bf785457-2ccc-4f9f-bc5e-bfadb4a688eb'
                  "
                  rounded="circle"
                  width="80"
                  height="80"
                  thumbnail
                  @click="isModalOpen = true"
                />
              </div>

              <b-badge @click="isModalOpen = true" variant="primary" class="cursor-pointer">
                Cliquez ici pour changer votre photo de profil
              </b-badge>
            </div>

            <h5 class="text-uppercase text-white mt-4">Email</h5>
            <input v-model="email" class="w-100" />

            <h5 class="text-uppercase text-white mt-4">First Name</h5>
            <input v-model="firstName" class="w-100" />

            <h5 class="text-uppercase text-white mt-4">Last Name</h5>
            <input v-model="lastName" class="w-100" />

            <h5 class="text-uppercase text-white mt-4">Display Name</h5>
            <input v-model="displayName" class="w-100" />

            <div class="text-right mt-4">
              <b-button @click="triggerUpdateAuth" variant="success" class="text-uppercase text-white">Sauvegarder</b-button>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>

    <b-modal v-model="isModalOpen" @hidden="isModalOpen = false" hide-header>
      <upload @success="triggerAvatarUpdate" />
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { UPDATE_AUTH } from "@/store/actions";

import { BRow, BCol, BImg, BButton, BModal, BBadge } from "bootstrap-vue";

import ProfileSidebar from "@/components/Auth/Sidebar";
import Upload from "@/components/Files/Upload";
import ExpandMenuIcon from "@/components/Common/ExpandMenuIcon";

export default {
  name: "Profile",
  components: { BRow, BCol, BImg, BButton, BModal, BBadge, ProfileSidebar, Upload, ExpandMenuIcon },
  computed: { ...mapGetters("auth", ["currentUser"]) },
  data: () => ({
    email: null,
    firstName: null,
    lastName: null,
    displayName: null,
    photoURL: null,

    isModalOpen: false,
  }),
  mounted() {
    const { email, firstName, lastName, displayName, photoURL } = this.currentUser;

    this.email = email;
    this.firstName = firstName || "";
    this.lastName = lastName || "";
    this.displayName = displayName || "";
    this.photoURL = photoURL;
  },
  methods: {
    ...mapActions("auth", { updateAuth: UPDATE_AUTH }),
    triggerUpdateAuth() {
      const { email, firstName, lastName, displayName } = this;
      this.updateAuth({ private: { email, firstName, lastName, displayName }, public: { displayName } });
    },
    triggerAvatarUpdate(value) {
      const { url: photoURL } = value;
      this.updateAuth({ public: { photoURL } });
      this.photoURL = photoURL;
    },
  },
};
</script>

<style scoped>
.main-page {
  padding-top: 100px;
  margin-right: 15px;
  margin-left: 0;
}
</style>
